import EditFaq from './EditFaq'
export default EditFaq